export default {
      id: "briefcase-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#briefcase",
      toString: function () {
        return this.url;
      }
    }